export interface Dialog {
  buttonConfig: DialogButton[];
  title: string;
  processText?: string;
  actionFlagLabel?: string;
  maxWidth?: string;
}

export interface DialogButton {
  callbackID: ButtonCallbacks;
  text: string;
  outlined?: boolean;
  icon?: string;
}

export enum ButtonCallbacks {
  ACTION,
  ADD,
  CANCEL,
  CLOSE,
  DELETE,
  DOWNLOAD,
  LOGIN,
  OK,
  SAVE
}
